import { TemplateId } from '@cibli/shared';

import type { RegisteredTemplate } from '../types';

import CompactDisplay from './Display';
import CompactEditPannel from './EditPannel';
import { compactDefaults, compactParamsSchema } from './schema';

const compactTemplate: RegisteredTemplate<typeof compactDefaults> = {
  meta: {
    id: 'ciblijob' as TemplateId,
    name: 'Compact',
  },
  schema: compactParamsSchema,
  defaults: compactDefaults,
  Display: CompactDisplay as unknown as RegisteredTemplate<typeof compactDefaults>['Display'],
  EditPannel: CompactEditPannel as unknown as RegisteredTemplate<
    typeof compactDefaults
  >['EditPannel'],
  pdfOptions: {
    printBackground: true,
  },
};

export default compactTemplate;
